import React from 'react';
import {Button, EMPHASIS, Frame, Text} from '@forecast-it/design-system';

/**
 * The pieces the time and expense estimate editors share, so the two keep the same look and the same
 * accessible names.
 */

/** The bordered, centred message shown when a phase has no lines of this kind, as on the Baseline page. */
export const EmptyEstimates = ({message}: {message: string}): JSX.Element => (
	<Frame centerContent>
		<Text color="auxiliary">{message}</Text>
	</Frame>
);

type RemoveRowButtonProps = {label: string; 'data-cy': string; onPress: () => void};

/** The row's ×, named for screen readers by `label`. */
export const RemoveRowButton = ({label, 'data-cy': dataCy, onPress}: RemoveRowButtonProps): JSX.Element => (
	<div>
		<Button emphasis={EMPHASIS.LOW} icon="close" aria-label={label} data-cy={dataCy} onPress={onPress} />
	</div>
);

type AddRowButtonProps = {label: string; 'data-cy': string; onPress: () => void};

export const AddRowButton = ({label, 'data-cy': dataCy, onPress}: AddRowButtonProps): JSX.Element => (
	<div>
		<Button emphasis={EMPHASIS.LOW} icon="plus" data-cy={dataCy} onPress={onPress}>
			{label}
		</Button>
	</div>
);
